// Dependencies imports ==>
import React, { useState, useEffect } from "react";
import moment from "moment";
import Popover from "react-popover";
import TitleSubtitleCard from "../../Modules/TitleSubtitleCard";
import CopyToClipboard from "react-copy-to-clipboard";
import { LOCALSTORAGEKEY } from "../../../../Util/Helper/localStorageUtils";
import { DEV, PROD, QA } from "../../config";
import Select from "react-select";
// assets and scss imports ⇒
import { Divider } from "@mui/material";
import { ContentCopyTwoTone } from "@mui/icons-material";
import CalendarIcon from "../../../../assets/calendar.svg";
import VerifiedIcon from "../../../../assets/verifiedGreenIcon.svg";
import PendingIcon from "../../../../assets/pendingRedIcon.svg";
import FailedIcon from "../../../../assets/failedRedIcon.svg";
import verifyAbhaIcon from "../../../../assets/open-link.svg";
import EditIcon from "../../../../assets/edit_white.svg";
// project file imports(UI Components) =>
import CommonPopup from "../../CommonPopup";
import FormInputWithHeader from "../../FormInputWithHeader";
import DatePickerNew from "../../../PhysicalConsultation/AgePicker";
// const file imports =>
import {
  GENDER_OPTIONS,
  ERRORSINTIAL,
  CONSULTATIONTYPE,
  UHID_DUPLICATE_ERROR,
  getUHIDFormatError,
  UHID_SINGLE_QUOTES_ERROR,
} from "../constant";
import { UPDATE_PATIENT_DETAILS } from "../ViewDetailsApiHandler/apiConstants";
import { GET_STATE_CITY } from "../../../MyPatientsViewAppointments/MyPatientsViewAppointmentsApiHandler/apiConstants";
import {
  GET_DOCTOR_LIST,
  GET_UHID_LIST,
} from "../../../PhysicalConsultation/APIHandler/apiConstants";
import {
  c2cGetApiHandler,
  c2cPostApiHandler,
} from "../../../../Util/c2cApiHandler";
import { APPOINTMENT_STATUS } from "../../../../Util/constants";
import Loader from "../../../UI Component/Loader/Loader";

const ViewDetailsMainModal = (props) => {
  const {
    openViewDetailsPopup,
    loading,
    appointment,
    closeView,
    appointment_id,
    appointmentDetails,
    editMode,
    appointmentJourney,
    appointment_status,
    editUhid,
    setEditMode,
    fetchAppointmentDetails,
    setOpenAlert,
    setAlertMsg,
    setPageLoader,
    setOpenViewDetailsPopup,
    setVerificationPopup,
    setVerificationError,
  } = props;
  const customStyles = {
    control: (base, state) => ({
      ...base,
      width: "286px",
      background: " #F5F6F7 0% 0% no-repeat padding-box",
      border: "1px solid #DBDBDB",
      borderRadius: "5px",
      height: "36px",
      marginTop: "5px",
      borderColor: state.isFocused ? "#DBDBDB" : base.borderColor, // Remove border color on focus
      "&:hover": {
        borderColor: state.isFocused ? "#DBDBDB" : base.borderColor, // Remove border color on hover
      },
      boxShadow: "none",
      opacity: state.isDisabled ? "0.4" : "1",
    }),
    container: (base) => ({
      ...base,
      maxWidth: "286px",
      textAlign: "left",
      backgroundColor: "#F5F6F7",
    }),
    menuList: (base) => ({
      ...base,
      backgroundColor: "#F5F6F7",
      "&::-webkit-scrollbar": {
        display: "none",
      },
      height: "148px",
    }),
    menu: (base) => ({
      ...base,
      height: "150px",
      overFlowY: "auto",
      boxShadow: "0px 3px 30px rgba(173, 173, 173, 0.3019607843)",
      border: "1px solid #eaeaea",
    }),
    ValueContainer: (base) => ({
      ...base,
      width: "85%",
      display: "inline-block",
    }),
    IndicatorsContainer: (base) => ({
      ...base,
      width: "10%",
      display: "inline-block",
      marginTop: "3px",
    }),
    indicatorContainer: (base) => ({
      ...base,
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected ? "#17bae0" : "inherit",
      color: state.isSelected ? "#fff" : "inherit",
      cursor: "pointer",
    }),
  };

  // const declarations ⇒

  const emailRegex = RegExp(/[\w-]+@([\w-]+\.)+[\w-]+/);
  const pincodeRegex = RegExp(/^[1-9]\d{5}$/);
  const onlyDigits = RegExp(/^\d{0,6}$/);
  const clinicId = localStorage.getItem(LOCALSTORAGEKEY.CLINIC_ID);
  const [abhaId, setAbhaId] = useState("");
  const [purposeOfConsultation, setPurposeOfConsultation] = useState("");
  const [patientDetailsError, setPatientDetailsError] = useState("");
  const [isOpen, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [patientName, setPatientName] = useState("");
  const [email, setEmail] = useState("");
  const [patientAddress, setPatientAddress] = useState("");
  const [pincode, setPincode] = useState("");
  const [genderOptions, setGenderOptions] = useState(GENDER_OPTIONS);
  const [error, setError] = useState(ERRORSINTIAL);
  const [referrelList, setReferrelList] = useState([]);
  const [referrelName, setReferrelName] = useState("");
  const [referredBy, setReferredBy] = useState("");
  const [stateName, setStateName] = useState("");
  const [stateCode, setStateCode] = useState("");
  const [d_year, setDyear] = useState("00");
  const [d_month, setDmonth] = useState("00");
  const [d_day, setDday] = useState("00");
  const [newDate, setNewDate] = useState("");
  const [referDropdown, setReferDropdown] = useState(false);
  const [age, setAge] = useState("");
  const [isUHidEnabled, setIsUHidEnabled] = useState(false);
  const [uhIdList, setUHIdList] = useState([]);
  const [uhidPrefix, setUHIdPrefix] = useState("");
  const [uhidInput, setUhidInput] = useState("");

  // ==> Actions

  const handleClose = () => {
    setEditMode(false);
    closeView();
  };

  const purposeOfAppointment =
    appointmentDetails.purpose_of_appointment?.trim() !== ""
      ? appointmentDetails.purpose_of_appointment?.trim()
      : "-";

  // Lifecycle Methods ==>

  useEffect(() => {
    if (editMode) {
      resetErrors();
      setAbhaId(
        appointmentDetails.preferred_abha_address
          ? appointmentDetails.preferred_abha_address
          : ""
      );
      setPurposeOfConsultation(
        appointmentDetails?.purpose_of_appointment?.trim()
      );
      //
      setPatientName(appointmentDetails?.patient_name);
      setEmail(appointmentDetails?.email);
      setPatientAddress(appointmentDetails?.patient_address);
      setPincode(appointmentDetails?.patient_pincode?.trim());
      setGenderValue(appointmentDetails?.patient_gender);
      setStateName(appointmentDetails?.patient_state_name);
      getDoctors(clinicId);
      setReferrelName(appointmentDetails?.referred_name);
      setStateCode(appointmentDetails?.patient_state_code);
      setReferredBy({
        label: appointmentDetails?.referred_by,
        value: appointmentDetails?.referred_by,
        doctor_id: appointmentDetails?.referred_id,
      });
      setAge(appointmentDetails?.patient_age);
      let patientAge = getOnlyAge(appointmentDetails?.patient_age);
      let date = extractDateComponents(appointmentDetails?.patient_age);
      setDday(date.days);
      setDyear(date.years);
      setDmonth(date.months);
      setNewDate(date);
      setUhidInput(appointmentDetails?.formatted_uhid);
    }
  }, [editMode]);

  useEffect(() => {
    if (clinicId) {
      getClinicUhidListApiCall();
    }
  }, []);

  // <===

  const extractDateComponents = (dateString) => {
    const yearRegex = /(\d+)\s*years?/;
    const monthRegex = /(\d+)\s*months?/;
    const dayRegex = /(\d+)\s*days?/;

    const yearMatch = dateString.match(yearRegex);
    const monthMatch = dateString.match(monthRegex);
    const dayMatch = dateString.match(dayRegex);

    const years = yearMatch ? parseInt(yearMatch[1], 10) : 0;
    const months = monthMatch ? parseInt(monthMatch[1], 10) : 0;
    const days = dayMatch ? parseInt(dayMatch[1], 10) : 0;

    return { years, months, days };
  };

  const setGenderValue = (val) => {
    let options = [...GENDER_OPTIONS];
    options.forEach((opt) => {
      opt.selected = opt.value === val;
    });
    setGenderOptions(options);
  };
  const getGenderValue = () => {
    let selected = genderOptions.find((obj) => obj.selected);
    return selected?.label ? selected.label : "";
  };

  const isPincodeValid = (pin) => {
    let payload = { pincode: pin };
    let isValidPin = c2cPostApiHandler(GET_STATE_CITY, payload);
    isValidPin.then(([res, err]) => {
      if (!err) {
        if (res?.data?.statusCode == 200) {
          setStateCode(res?.data?.data?.state_code);
          let state = res?.data?.data?.state_name;
          setStateName(state);
          setError({
            ...error,
            pincode: "",
          });
        } else {
          setError({
            ...error,
            pincode: "Please enter valid pincode.",
          });
        }
      } else {
        setError({
          ...error,
          pincode: "Please enter valid pincode.",
        });
      }
    });
  };
  const resetErrors = () => {
    setError(ERRORSINTIAL);
  };
  const updatePatientDetailsAPICall = (payload) => {
    const patientDetailsResponse = c2cPostApiHandler(
      UPDATE_PATIENT_DETAILS,
      payload
    );
    patientDetailsResponse.then(([res, err]) => {
      if (!err) {
        if (res?.data?.statusCode === 200) {
          setPatientDetailsError("");
          setEditMode(false);
          fetchAppointmentDetails();
        } else {
          setPatientDetailsError(
            "Patient Details not updated. Please try again."
          );
          setEditMode(false);
        }
      } else {
        setPatientDetailsError(
          "Patient Details not updated. Please try again."
        );
        setEditMode(false);
      }
    });
  };

  const getClinicUhidListApiCall = () => {
    const uhIdResponse = c2cGetApiHandler(GET_UHID_LIST(clinicId));
    uhIdResponse.then(([res, err]) => {
      if (!err) {
        if (res.data.patient_uhid_enabled) {
          if (res.data.existing_patient_uhids?.length > 0) {
            res.data.existing_patient_uhids.forEach((d) => {
              let word = d.formatted_uhid.match(/\D+/g);
              let digits = d.formatted_uhid.match(/\d+/g);
              d["uhid_prefix"] = word?.length > 0 ? word[0] : "";
              d["uhid_no"] = digits?.length > 0 ? Number(digits[0]) : "";
            });
          }
          setUHIdPrefix(res?.data?.patient_uhid_prefix?.trim());
          setUHIdList(res?.data.existing_patient_uhids);
        } else {
          setUHIdList([]);
        }
        setIsUHidEnabled(res.data.patient_uhid_enabled);
      }
    });
  };
  // Actions ===>

  const handleCopyToClip = () => {
    setOpenAlert(true);
    setAlertMsg("Address has been copied");
    setTimeout(() => {
      setOpenAlert(false);
    }, 2000);
  };

  const handlePopoverOpen = (event) => {
    setOpen(true);
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setOpen(false);
    setAnchorEl(null);
  };

  const handleEdit = () => {
    setEditMode(true);
  };

  const handlePOCChange = (e) => {
    setPurposeOfConsultation(e.target.value);
  };

  const handleAbhaIdChange = (e) => {
    setAbhaId(e.target.value);
  };
  const handlePatientName = (e) => {
    let value = e.target.value;
    if (value.length === 0) {
      setError({ ...error, patientName: "Please enter patient name." });
    } else {
      setError({ ...error, patientName: "" });
    }
    setPatientName(e.target.value);
  };

  const handleEmail = (e) => {
    let value = e.target.value;
    if (!emailRegex.test(e.target.value) && value.length !== 0) {
      setError({ ...error, email: "Please enter valid email." });
    } else {
      setError({ ...error, email: "" });
    }
    setEmail(e.target.value);
  };

  const handlePatientAddress = (e) => {
    setPatientAddress(e.target.value);
  };

  const handlePincodeChange = (e) => {
    let value = e.target.value;
    if (value.length === 0 || !pincodeRegex.test(e.target.value)) {
      setError({ ...error, pincode: "Please enter valid pincode." });
    } else {
      isPincodeValid(value);
    }
    if (onlyDigits.test(value)) {
      setPincode(e.target.value);
    }
  };
  const handleGenderChange = (val) => {
    setGenderValue(val.value);
  };

  const handleReferealName = (ele) => {
    setReferrelName(ele.target.value);
  };

  const handleReferredBySelect = (ele) => {
    let obj = ele
      ? {
          label: ele.label,
          value: ele.value,
          doctor_id: ele.doctor_id,
        }
      : "";

    setReferredBy(obj);
    setReferrelName("");
  };

  const onSaveClick = () => {
    let payload = {
      appointment_id: appointment_id,
      data: {
        preferred_abha_address: abhaId,
        purpose_of_appointment: purposeOfConsultation,
        patient_name: patientName,
        patient_age: age,
        patient_state_name: stateName,
        patient_state_code: stateCode,
        patient_full_address: patientAddress,
        patient_pincode: pincode,
        referred_by: referredBy.label,
        referred_id: referredBy.doctor_id,
        referred_name: referrelName,
        email: email,
        patient_gender: getGenderValue(),
        formatted_uhid: uhidInput?.trim()?.toUpperCase(),
      },
    };
    let isError = Object.values(error).some((val) => val !== "");
    if (!isError) {
      setPageLoader(true);
      updatePatientDetailsAPICall(payload);
      if (clinicId && isUHidEnabled) {
        getClinicUhidListApiCall();
      }
    }
  };

  const onCancelClick = () => {
    setEditMode(false);
  };

  const handleUhidInput = (e) => {
    let enteredVal = e.target.value;
    setUhidInput(enteredVal);
    let regEx = /^[A-Za-z]+[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]{0,1}[/d]+$/;
    let single_double_quote_regex = /['||"]/;
    let newArr = uhIdList?.length > 0 ? [...uhIdList] : [];
    if (enteredVal.length > 0) {
      if (
        appointmentDetails?.formatted_uhid?.toLowerCase()?.trim() ===
        enteredVal?.toLowerCase()?.trim()
      ) {
        setError({ ...error, uhid: "" });
      } else {
        if (single_double_quote_regex.test(enteredVal)) {
          setError({ ...error, uhid: UHID_SINGLE_QUOTES_ERROR });
        } else {
          if (uhidPrefix) {
            if (regEx.test(enteredVal)) {
              let word = e.target.value.match(/\D+/g);
              let digits = e.target.value.match(/\d+/g);
              if (word.length > 0) {
                if (word[0]?.toLowerCase() === uhidPrefix?.toLowerCase()) {
                  if (digits.length > 0) {
                    if (newArr?.length > 0) {
                      let index = newArr.findIndex(
                        (d) => d.uhid_no === Number(digits[0])
                      );
                      if (index > -1) {
                        setError({ ...error, uhid: UHID_DUPLICATE_ERROR });
                      } else {
                        setError({ ...error, uhid: "" });
                      }
                    } else {
                      setError({ ...error, uhid: "" });
                    }
                  }
                } else {
                  setError({ ...error, uhid: getUHIDFormatError(uhidPrefix) });
                }
              }
            } else {
              setError({ ...error, uhid: getUHIDFormatError(uhidPrefix) });
            }
          } else {
            let duplicateUHID = newArr.filter(
              (existingUHID) =>
                existingUHID?.formatted_uhid?.toLowerCase()?.trim() ===
                enteredVal?.toLowerCase()?.trim()
            );
            if (duplicateUHID?.length > 0) {
              setError({ ...error, uhid: UHID_DUPLICATE_ERROR });
            } else {
              setError({ ...error, uhid: "" });
            }
          }
        }
      }
    } else {
      setError({ ...error, uhid: "" });
    }
  };

  // <===

  // Helper Methods ==>

  const getAbhaStatusIcon = () => {
    if (
      appointmentDetails?.abha_address_kyc_verified?.toLowerCase() === "true"
    ) {
      return VerifiedIcon;
    } else if (
      appointmentDetails?.abha_address_kyc_verified?.toLowerCase() === "false"
    ) {
      return FailedIcon;
    } else {
      return PendingIcon;
    }
  };

  function renderConsultationType(
    appointmentType,
    consultationType,
    procedureName,
    allAppointmentProcedures
  ) {
    let appointmentTypeText =
      appointmentType === "in-clinic" ? "In-Clinic" : "Tele-Consult";
    switch (appointmentType) {
      case CONSULTATIONTYPE.ONLINE:
        if (consultationType === CONSULTATIONTYPE.INSTANT) {
          return <span>Instant</span>;
        }
        if (consultationType === CONSULTATIONTYPE.FOLLOWUP) {
          return <span>{appointmentTypeText + " Follow-Up"}</span>;
        }
        return <span>{appointmentTypeText + " Regular"}</span>;
      case CONSULTATIONTYPE.REGULAR.toLowerCase():
        return <span>{appointmentTypeText + " Regular"}</span>;
      case CONSULTATIONTYPE.FOLLOWUP:
        return <span>{appointmentTypeText + " Follow-Up"}</span>;
      case CONSULTATIONTYPE.PROCEDURE:
        return <span>{procedureName}</span>;
      case CONSULTATIONTYPE.INCLINIC:
        if (consultationType === CONSULTATIONTYPE.PROCEDURE) {
          return (
            <span>
              {allAppointmentProcedures !== ""
                ? allAppointmentProcedures
                : procedureName}
            </span>
          );
        }
        return (
          <span>
            {allAppointmentProcedures !== ""
              ? allAppointmentProcedures
              : appointmentTypeText + " Consultation"}
          </span>
        ); // fix for 7043
      default:
        return "";
    }
  }

  function renderPaymentMethod(appnt) {
    if (appnt.appointment_type === "online") {
      return "Online via C2C";
    } else {
      if (appnt.all_payment_mode) {
        let dup = appnt.all_payment_mode.split(",");
        let removeDup = dup.filter((c, index) => {
          return dup.indexOf(c) === index;
        });
        removeDup.map((data, index) => {
          if (data.toLowerCase() === "online via c2c") {
            removeDup[index] = "Online via C2C";
          } else if (data.toLowerCase().includes("cash")) {
            if (appointment_status !== "completed") {
              removeDup[index] = "Pay at Clinic";
            } else {
              removeDup[index] = "Paid at Clinic - By Cash";
            }
          } else {
            removeDup[index] = `Paid at Clinic - ${data}`;
          }
        });
        return `${
          removeDup !== undefined &&
          removeDup.length > 0 &&
          removeDup.map((data) => data).join(" ,\n")
        }`;
      }
    }
  }

  const isReferralDisabled = () => {
    const disabledFor = [
      APPOINTMENT_STATUS.COMPLETED,
      APPOINTMENT_STATUS.CANCELLED,
      APPOINTMENT_STATUS.NO_SHOW,
    ];
    const currentDate = moment();
    const appntDate = moment(appointment.appointment_date);

    return (
      disabledFor.includes(appointment_status?.toLowerCase()) ||
      appntDate.isBefore(currentDate, "day")
    );
  };

  const isSaveDisabled = () => {
    return (
      !isReferralDisabled() &&
      (referredBy?.value === "Other" || referredBy?.value === "Organization") &&
      referrelName?.length === 0
    );
  };
  const getAge = (date) => {
    let startDate = moment(date, "YYYY-MM-DD");
    let endDate = moment();
    const duration = moment.duration(endDate.diff(startDate));
    let displaydob = moment(date).format("DD MMM YYYY");
    let year =
      `${duration.years() != "0" ? duration.years() + " Years " : ""}` +
      `${duration.months() > "0" ? duration.months() + " Months " : ""}` +
      `${duration.days() > "0" ? duration.days() + " Days " : ""}`;

    return displaydob + "/" + year;
  };

  const getOnlyAge = (data) => {
    let arr = data.toLowerCase().split(" ");
    let ageValue = "";
    if (arr.length >= 6) {
      let year = arr[0];
      let month = arr[2];
      let day = arr[4];
      if (year != "" && month != "" && day != "") {
        year = Number(year);
        month = Number(month);
        day = Number(day);
        if (year > 0) {
          ageValue =
            year +
            " Years " +
            (month > 0 ? month + " Months " : "") +
            (day > 0 ? day + " Days" : "");
        } else {
          ageValue =
            (month > 0 ? month + " Months " : "") +
            (day > 0 ? day + " Days " : "");
        }
      }
    }
    return ageValue;
  };

  // <===

  const getDOB = () => {
    let age = "";
    if (
      appointmentDetails.patient_dob == "" &&
      appointmentDetails.patient_age != ""
    ) {
      const { years, months, days } = extractDateComponents(
        appointmentDetails.patient_age
      );
      age += years > 0 ? `${years} years ` : "";
      age += months > 0 ? `${months} months ` : "";
      age += days > 0 ? `${days} days ` : "";
    }

    return (
      <>
        {appointmentDetails.patient_dob != "" &&
          getAge(appointmentDetails.patient_dob)}
        {age}
      </>
    );
  };

  const handleAge = (year, month, day) => {
    const isValidInput = (value) =>
      !isNaN(value) &&
      (typeof value === "number" ||
        (typeof value === "string" ? !isNaN(Number(value)) : false));

    if (isValidInput(year) || isValidInput(month) || isValidInput(day)) {
      let patientAge = "";
      if (isValidInput(year)) {
        patientAge += `${year} years `;
        setDyear(year);
      } else {
        patientAge += "00 years ";
      }

      if (isValidInput(month)) {
        patientAge += `${month} months `;
        setDmonth(month);
      } else {
        patientAge += "00 months ";
      }

      if (isValidInput(day)) {
        patientAge += `${day} days`;
        setDday(day);
      } else {
        patientAge += "00 days";
      }
      const parts = patientAge.split(" ");
      let valid = false;
      parts.forEach((part) => {
        const num = parseInt(part, 10);
        if (!isNaN(num) && num >= 1) {
          valid = true;
        }
      });
      if (!valid) {
        setError({ ...error, dob: "Please enter valid age" });
      } else {
        setError({ ...error, dob: "" });
      }
      setAge(patientAge);
      setNewDate("");
    }
  };

  const getAbhaAddress = (abhaAddress) => {
    return `${
      abhaAddress + (process.env.REACT_APP_ENV !== PROD ? "@sbx" : "@abdm")
    }`;
  };

  const getConsultationType = () => {
    return (
      <>
        {appointment?.account_type !== 1 && (
          <>
            <span style={{ textTransform: "capitalize" }}>
              {appointmentDetails.appointment_type}
            </span>{" "}
            :{" "}
          </>
        )}
        {renderConsultationType(
          appointmentDetails.appointment_type,
          appointmentDetails.consultation_type,
          appointmentDetails.procedure_name,
          appointmentDetails.all_procedure_name
        )}
      </>
    );
  };

  const getAbhaStatus = () => {
    return (
      <>
        <div className="vd-abha-status-container">
          <div
            className={
              "vd-abha-status " +
              (appointmentDetails?.abha_address_kyc_verified?.toLowerCase() ===
              "true"
                ? "vd-abha-status-verified"
                : "vd-abha-status-failed")
            }
          >
            <div>
              <img
                className="vd-abha-status-icon"
                src={getAbhaStatusIcon()}
                alt=""
              />
            </div>
            <div>{appointmentDetails?.abha_address_kyc_status}</div>
          </div>
        </div>
      </>
    );
  };
  const getDoctors = (id) => {
    if (id == null) return;
    let params = { clinic_id: clinicId };
    let docList = c2cGetApiHandler(GET_DOCTOR_LIST, params);
    docList.then(([res, err]) => {
      if (!err) {
        let arr1 = res?.data?.doctor_list?.map((ele, i) => {
          return {
            label: ele.doctor_name,
            chipLabel: ele.specialization,
            value: i,
            doctor_id: ele.doctor_id,
          };
        });
        let arr2 = res.data.referral_doctors?.map((ele, i) => {
          return {
            label: ele.name,
            chipLabel: ele.specialization,
            value: i,
            doctor_id: ele.doctor_id,
          };
        });
        let referList = [
          ...arr1,
          ...arr2,
          { label: "Other", value: "Other" },
          { label: "Organization", value: "Organization" },
        ];
        setReferrelList(referList);
        if (appointmentDetails?.referral_id) {
          // TODO handle for other and organisation
          let selectedRefDoc = referList?.find(
            (obj) => obj.doctor_id === appointmentDetails?.referral_id
          );
          if (selectedRefDoc) {
            setReferredBy({
              label: selectedRefDoc.label,
              value: selectedRefDoc.value,
              doctor_id: selectedRefDoc.doctor_id,
            });
          }
        }
      } else {
        setReferrelList([]);
      }
    });
  };
  // Create UI ==>
  const displayModalBody = () => {
    return (
      <div className="view-detail">
        {loading && <Loader />}
        <div className="width-full view-details-date-wrapper">
          <p className="appt-time-content view-details-date px-3">
            <img
              src={CalendarIcon}
              alt=""
              style={{ width: "30px", paddingRight: "10px" }}
            />
            <span>
              {moment(appointmentDetails.appointment_date).format(
                "MMM DD, YYYY"
              )}
              {" at "}
              {moment(
                appointmentDetails.appointment_start_time,
                "hh:mmZ"
              ).format("hh:mm A")}
            </span>
          </p>
        </div>
        <Divider />
        <div className="view-details-scroll view-details-data-journey">
          <div className="view-patient-details">{displayDetails()}</div>
          <div className="view-appointment-journey-details">
            {appointmentJourney.length > 0 && displayAppointmentJourney()}
          </div>
        </div>
      </div>
    );
  };

  const createCustomOptions = ({ value, label, chipLabel }) => {
    return <div className="view-details-modal-custom-opt">{label}</div>;
  };
  const createReferredByUI = () => {
    return (
      <>
        <div
          className="title-text view-details-list-content "
          htmlFor="reactstate"
        >
          Referred By
        </div>
        <div
          style={{
            cursor: isReferralDisabled() ? "not-allowed" : "pointer",
          }}
        >
          <Select
            isClearable
            isSearchable
            options={referrelList}
            formatOptionLabel={createCustomOptions}
            placeholder=""
            onChange={(e) => handleReferredBySelect(e)}
            value={referredBy}
            defaultValue={appointmentDetails?.referred_by}
            styles={customStyles}
            name={"referred_by"}
            onMenuOpen={() => setReferDropdown(true)}
            onMenuClose={() => setReferDropdown(false)}
            components={{
              DropdownIndicator: () => null,
              IndicatorSeparator: () => null,
            }}
            isDisabled={isReferralDisabled()}
          />
        </div>
      </>
    );
  };
  const createReferenceUI = () => {
    return clinicId !== null ? (
      <div className="">{createReferredByUI()}</div>
    ) : null;
  };

  const displayDetails = () => {
    return (
      <>
        <div className="view-details-header">
          <div>DETAILS</div>
          {patientDetailsError && (
            <div className="update-details-error">{patientDetailsError}</div>
          )}
          {!editMode && (
            <div className="view-patient-details-edit-btn-section">
              <div
                className="view-patient-details-edit-btn"
                onClick={() => handleEdit()}
              >
                <img src={EditIcon} alt="" />
                {"Edit"}
              </div>
            </div>
          )}
        </div>
        <div className="view-details-poc view-details-list-wrapper">
          {displayPatientDetails()}
        </div>
      </>
    );
  };

  const displayPatientDetails = () => {
    return (
      <>
        {displayPatientName()}
        {displayPurposeOfConsultation()}
        {displayPatientGender()}
        {displayPatientAgeDOB()}
        {displayPatientPhoneNumnber()}
        {displayPatientUHID()}
        {displayPatientEmail()}
        {displayABDMHFRID()}
        {displayPatientState()}
        {displayPatientAddress()}
        {displayPatientPinCode()}
        {displayPaymentMethod()}
        {displayProcedure()}
        {displayPatientReference()}
      </>
    );
  };

  const displayPatientName = () => {
    return (
      <div className="view-details-list-content-wrapper view-details-list-content">
        <div className="title-text view-details-list-content">
          Patient Name
          {editMode && <span className="color-pink">*</span>}
        </div>
        {editMode ? (
          <>
            {" "}
            <div className="edit-input">
              <FormInputWithHeader
                handleOnChangeInput={handlePatientName}
                className="view-details-poc-input"
                value={patientName}
              ></FormInputWithHeader>
            </div>
            {error.patientName && (
              <div className="view-details-modal-error">
                {error.patientName}
              </div>
            )}
          </>
        ) : (
          <TitleSubtitleCard subtitle={appointmentDetails.patient_name} />
        )}
      </div>
    );
  };

  const displayPurposeOfConsultation = () => {
    return (
      <div className=" view-details-list-content-wrapper view-details-poc view-details-list-content">
        <div className="title-text view-details-list-content">
          Purpose of Consultation{" "}
        </div>
        {editMode ? (
          <div className="edit-input">
            <FormInputWithHeader
              handleOnChangeInput={handlePOCChange}
              className="view-details-poc-input"
              value={purposeOfConsultation}
            ></FormInputWithHeader>
          </div>
        ) : (
          <div className="subtitle-text d-flex">
            <Popover
              isOpen={isOpen}
              preferPlace={`below`}
              place={null}
              anchorEl={anchorEl}
              body={
                <div style={{ maxWidth: "170px", overflowWrap: "anywhere" }}>
                  {purposeOfAppointment}
                </div>
              }
            >
              <div
                className="view-details-poc-value"
                onMouseOver={handlePopoverOpen}
                onMouseOut={handlePopoverClose}
              >
                {purposeOfAppointment}
              </div>
              {purposeOfAppointment?.length > 20 ? " ..." : ""}
            </Popover>
          </div>
        )}
      </div>
    );
  };

  const displayPatientGender = () => {
    return (
      <div className="view-details-list-content-wrapper view-details-list-content">
        <div className="title-text view-details-poc view-details-list-content">
          Gender {editMode && <span className="color-pink">*</span>}
        </div>
        {editMode ? (
          <div className="edit-input view-details-poc-input-gender">
            <FormInputWithHeader
              className="view-details-poc-input"
              value={getGenderValue()}
              inputType="dropdown"
              options={genderOptions}
              handleOnChangeInput={handleGenderChange}
            ></FormInputWithHeader>
          </div>
        ) : (
          <TitleSubtitleCard subtitle={appointmentDetails.patient_gender} />
        )}
      </div>
    );
  };

  const displayPatientAgeDOB = () => {
    return (
      <div className="view-details-list-content-wrapper view-details-list-content">
        <div className="title-text view-details-list-content">
          {!editMode ||
          (editMode &&
            appointmentDetails?.patient_dob &&
            appointmentDetails?.patient_age)
            ? "Date of Birth/Age"
            : "Age"}
          {editMode && <span className="color-pink">*</span>}
        </div>
        {appointmentDetails?.patient_dob === "" &&
        appointmentDetails?.patient_age &&
        editMode ? (
          createDobUi()
        ) : (
          <TitleSubtitleCard subtitle={getDOB()} />
        )}
      </div>
    );
  };

  const displayPatientPhoneNumnber = () => {
    return (
      <div className="view-details-list-content-wrapper view-details-list-content">
        <TitleSubtitleCard
          title="Mobile Number"
          subtitle={appointmentDetails.phone_no}
        />
      </div>
    );
  };

  const displayPatientUHID = () => {
    return (
      <>
        {editMode &&
        appointmentDetails?.manual_uhid?.toLowerCase() === "true" &&
        isUHidEnabled &&
        clinicId ? (
          <div className="view-details-list-content-wrapper view-details-poc view-details-list-content">
            <div className="title-text view-details-list-content">UHID</div>
            <div className="edit-input">
              <FormInputWithHeader
                handleOnChangeInput={handleUhidInput}
                className="view-details-poc-input"
                value={uhidInput}
                autoFocus={editUhid}
              ></FormInputWithHeader>
            </div>
            {error.uhid && (
              <div className="view-details-modal-error">{error.uhid}</div>
            )}
          </div>
        ) : appointmentDetails?.formatted_uhid || isUHidEnabled ? (
          <div className="view-details-list-content-wrapper view-details-uhid view-details-list-content">
            <TitleSubtitleCard
              title="UHID"
              subtitle={
                appointmentDetails?.formatted_uhid
                  ? appointmentDetails?.formatted_uhid
                  : "-"
              }
            />
          </div>
        ) : null}
      </>
    );
  };

  const displayPatientEmail = () => {
    return (
      <>
        <div className="view-details-list-content-wrapper view-details-poc view-details-email view-details-list-content">
          <div className="title-text view-details-list-content">Email</div>
          {editMode ? (
            <>
              <div className="edit-input">
                <FormInputWithHeader
                  handleOnChangeInput={handleEmail}
                  className="view-details-poc-input"
                  value={email}
                ></FormInputWithHeader>
              </div>
              {error.email && (
                <div className="view-details-modal-error">{error.email}</div>
              )}
            </>
          ) : (
            <TitleSubtitleCard
              subtitle={
                appointmentDetails?.email?.trim()
                  ? appointmentDetails?.email?.trim()
                  : "-"
              }
            />
          )}
        </div>
      </>
    );
  };

  const displayABDMHFRID = () => {
    return (
      <>
        {(process.env.REACT_APP_ENV === DEV ||
          process.env.REACT_APP_ENV === QA ||
          window.location.hostname === "localhost") && (
          <>
            {appointmentDetails?.abdm_hfr_id && (
              <div className="view-details-list-content-wrapper ">
                {displayAbhaStatus()}
              </div>
            )}
          </>
        )}
      </>
    );
  };

  const displayPatientState = () => {
    return (
      <div className="view-details-list-content-wrapper view-details-list-content">
        <div className="title-text view-details-list-content">State</div>
        {editMode ? (
          <div className="edit-input">
            <FormInputWithHeader
              disabled
              className="view-details-poc-input"
              value={stateName}
            ></FormInputWithHeader>
          </div>
        ) : (
          <TitleSubtitleCard
            subtitle={
              appointmentDetails?.patient_state_name?.trim()
                ? appointmentDetails.patient_state_name
                : "-"
            }
          />
        )}
      </div>
    );
  };

  const displayPatientAddress = () => {
    return (
      <div className="view-details-list-content-wrapper view-details-poc view-details-list-content">
        <div className="title-text view-details-list-content">
          Address
          {!editMode && appointmentDetails?.patient_address?.trim() && (
            <CopyToClipboard
              onCopy={() => handleCopyToClip()}
              text={appointmentDetails.patient_full_address}
            >
              <span
                data-tooltip="Copy"
                data-tooltip-conf="bottom"
                style={{ color: "#17BAE0", marginLeft: "5px" }}
              >
                <ContentCopyTwoTone fontSize="small" cursor="pointer" />
              </span>
            </CopyToClipboard>
          )}
        </div>
        {editMode ? (
          <div className="edit-input view-details-modal-address-input">
            <textarea
              onChange={handlePatientAddress}
              className="view-details-poc-input"
              value={patientAddress}
            ></textarea>
            {error.patientAddress && (
              <div className="view-details-modal-error">
                {error.patientAddress}
              </div>
            )}
          </div>
        ) : (
          <div className="subtitle-text">
            {appointmentDetails?.patient_full_address?.trim()
              ? appointmentDetails.patient_full_address
              : "-"}
          </div>
        )}
      </div>
    );
  };

  const displayPaymentMethod = () => {
    return (
      <div className="view-details-list-content-wrapper subtitle-small-case view-details-list-content">
        <TitleSubtitleCard
          title="Payment Method"
          subtitle={renderPaymentMethod(appointmentDetails)}
        />
      </div>
    );
  };

  const displayProcedure = () => {
    return (
      <div className="width-half view-details-list-content">
        <TitleSubtitleCard title="Procedure" subtitle={getConsultationType()} />
      </div>
    );
  };

  const displayPatientReference = () => {
    return (
      <>
        {clinicId !== null &&
          appointmentDetails.consultation_type !== "instant" && (
            <div className="view-details-poc view-details-list-content-wrapper view-details-list-content">
              {editMode ? (
                createReferenceUI()
              ) : (
                <TitleSubtitleCard
                  title="Referred By"
                  subtitle={
                    appointmentDetails?.referred_by
                      ? appointmentDetails.referred_by
                      : "-"
                  }
                />
              )}
            </div>
          )}
        {(clinicId !== null || !CONSULTATIONTYPE?.INSTANT) && (
          <div className="view-details-list-content-wrapper view-details-list-content">
            {((!editMode && appointmentDetails?.referred_name) || editMode) && (
              <div className="title-text view-details-list-content">
                Referral Name
              </div>
            )}
            {editMode ? (
              <div
                style={{
                  opacity:
                    referredBy?.label !== "Other" &&
                    referredBy?.label !== "Organization"
                      ? "0.4"
                      : "1",
                }}
              >
                <div className="edit-input">
                  <FormInputWithHeader
                    handleOnChangeInput={(e) => handleReferealName(e)}
                    className="view-details-poc-input"
                    value={referrelName}
                    disabled={
                      (referredBy?.label !== "Other" &&
                        referredBy?.label !== "Organization") ||
                      isReferralDisabled()
                    }
                    maxLength={60}
                  ></FormInputWithHeader>
                </div>
              </div>
            ) : (
              appointmentDetails?.referred_name && (
                <TitleSubtitleCard
                  subtitle={
                    appointmentDetails?.referred_name
                      ? appointmentDetails.referred_name
                      : ""
                  }
                />
              )
            )}
          </div>
        )}
      </>
    );
  };

  const displayPatientPinCode = () => {
    return (
      <div className="view-details-list-content-wrapper view-details-poc view-details-list-content">
        <div className="title-text view-details-list-content">
          Pincode
          {editMode && <span className="color-pink">*</span>}
        </div>
        {editMode ? (
          <div className="edit-input">
            <FormInputWithHeader
              handleOnChangeInput={handlePincodeChange}
              className="view-details-poc-input"
              value={pincode}
            ></FormInputWithHeader>
            {error.pincode && (
              <div className="view-details-modal-error">{error.pincode}</div>
            )}
          </div>
        ) : (
          <TitleSubtitleCard
            subtitle={
              appointmentDetails?.patient_pincode?.trim()
                ? appointmentDetails.patient_pincode
                : "-"
            }
          />
        )}
      </div>
    );
  };

  const getAppointmentHistorySubtitle = (appnt, ind) => {
    return (
      <>
        <b>{appnt.action_name}</b>{" "}
        <span style={{ fontWeight: "300" }}>
          ({"By "}
          {appnt.action_taken_by})
        </span>
        {appnt.rescheduled_slot_date_time &&
          appnt.action_name === "Booking Rescheduled" &&
          ind && (
            <span style={{ display: "block", paddingTop: "5px" }}>
              To{" "}
              {moment(appnt.rescheduled_slot_date_time).format(
                "MMM DD, YYYY, hh:mm A"
              )}{" "}
              from{" "}
              {appointmentJourney[ind - 1].rescheduled_slot_date_time
                ? moment(
                    appointmentJourney[ind - 1].rescheduled_slot_date_time
                  ).format("MMM DD, YYYY, hh:mm A")
                : moment(
                    appointmentJourney[ind - 2].rescheduled_slot_date_time
                  ).format("MMM DD, YYYY, hh:mm A")}
              {/* in case of checked in appointment gets rescheduled, taking the rescheduled_slot_date_time from the booking confirmed action */}
            </span>
          )}
      </>
    );
  };
  const displayAbhaStatus = () => {
    return (
      <div className="view-details-modal-abha">
        <TitleSubtitleCard
          title="ABHA Status"
          className="view-details-poc-input"
          subtitle={
            editMode ? (
              <FormInputWithHeader
                handleOnChangeInput={handleAbhaIdChange}
                value={abhaId}
              ></FormInputWithHeader>
            ) : appointmentDetails.preferred_abha_address ? (
              getAbhaAddress(appointmentDetails.preferred_abha_address)
            ) : (
              "-"
            )
          }
        />
        {!editMode && appointmentDetails?.preferred_abha_address && (
          <div>{getAbhaStatus()}</div>
        )}
        {appointmentDetails?.abha_address_kyc_verified?.toLowerCase() !==
          "true" &&
          appointmentDetails?.preferred_abha_address &&
          !editMode && (
            <div className="verify-abha-link">
              <div
                onClick={() => {
                  setOpenViewDetailsPopup(false);
                  setVerificationError("");
                  setVerificationPopup(true);
                }}
                className="verify-abha-link-text"
              >
                Verify Abha Address{" "}
                <img className="ml-2" src={verifyAbhaIcon} alt="#" />
              </div>
            </div>
          )}
      </div>
    );
  };
  const renderDateOfBirth = () => {
    return (
      <div className="view-details-modal-age-picker">
        <DatePickerNew
          handleAge={handleAge}
          age={age}
          d_day={Number(d_day)}
          d_month={Number(d_month)}
          d_year={Number(d_year)}
          setDday={setDday}
          setDyear={setDyear}
          setDmonth={setDmonth}
          newDate={newDate}
          disableAge={false}
        />
      </div>
    );
  };

  const createDobUi = () => {
    return (
      <div className="edit-input view-details-modal-edit-dob">
        {renderDateOfBirth()}
        {error.dob && (
          <p className="view-details-modal-error">Please enter valid age</p>
        )}
      </div>
    );
  };
  const displayAppointmentJourney = () => {
    let bookingConfirmed = appointmentJourney.filter(
      (ap) => ap.action_name === "Booking Confirmed"
    );
    let journey = appointmentJourney.filter(
      (ap) => ap.action_name !== "Booking Confirmed"
    );
    return (
      <div className="view-details-journer">
        <div className="view-details-header">APPOINTMENT JOURNEY</div>
        {bookingConfirmed.length > 0 && (
          <div className="get-started-tree-lines-holder">
            <div className="width-full view-appointment-history-steps view-appointment-booking-history">
              <span className="view-appointment-history-dot"></span>
              <TitleSubtitleCard
                title={moment(bookingConfirmed[0].action_time).format(
                  "MMM DD, YYYY, hh:mm A"
                )}
                subtitle={getAppointmentHistorySubtitle(bookingConfirmed[0])}
              />
            </div>
            {journey.length > 0 && (
              <div style={{ paddingBottom: "25px", marginLeft: "15px" }}>
                <Divider />
              </div>
            )}
          </div>
        )}

        {journey.length > 0 && (
          <>
            <div>
              {appointmentJourney.map(
                (his, ind) =>
                  his.action_name !== "Booking Confirmed" && (
                    <div key={ind} className="get-started-tree-lines-holder">
                      <div className="width-full view-appointment-history-steps view-appointment-history">
                        <span className="view-appointment-history-dot"></span>
                        <TitleSubtitleCard
                          title={moment(his.action_time).format(
                            "MMM DD, YYYY, hh:mm A"
                          )}
                          subtitle={getAppointmentHistorySubtitle(his, ind)}
                        />
                      </div>
                    </div>
                  )
              )}
            </div>
          </>
        )}
      </div>
    );
  };
  const getTitle = () => {
    return (
      <>
        <h5 className="mb-0">Appointment Details</h5>
      </>
    );
  };
  return (
    <CommonPopup
      openPopup={openViewDetailsPopup}
      classes={{
        dialogPaper: editMode
          ? "view-details-modal view-details-modal-edit-mode"
          : "view-details-modal",
      }}
      hideCloseText
      hideFooter={!editMode}
      handleClosePopup={handleClose}
      heading={getTitle()}
      subtitle={displayModalBody()}
      leftBtn="Save"
      disableLeft={isSaveDisabled()}
      rightBtn="Cancel"
      handleLeftBtnClick={onSaveClick}
      handleRightBtnClick={onCancelClick}
    ></CommonPopup>
  );
};

export default ViewDetailsMainModal;
